<template>
  <div>

    <!-- Modal -->
<!--    <div class="modal fade in" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"-->
<!--         aria-hidden="false" style="display: block;">-->
<!--      <div class="modal-dialog">-->
<!--        <div class="modal-content">-->
<!--          <div class="modal-header">-->
<!--            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>-->
<!--            <h4 class="modal-title" id="myModalLabel">Contact Skippr</h4>-->
<!--          </div>-->
<!--          <div class="modal-body" style="max-height: 800px; overflow: scroll;">-->

<!--            <div class="row">-->

<!--              <div class="col-xs-12">-->

<!--                <div class="row">-->


                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-sm-offset-3">

                      <!--        <h2>Contact Us</h2>-->
                      <em>Tell us about yourself</em><br/>
                      <!--          <em>We'll redirect you to AWS where you can review and deploy Skippr</em>-->

                      <div className="m-t" role="form" _lpchecked="1">
                        <input id="deploy-skippr" type="hidden" name="_token"
                               value="TVkumuyrNWs5Z2OdjyHv2FKxaKnnbMPJxAasm9Db">

                        <div className="form-group">
                          <input id="first_name" type="text" className="form-control" name="first_name"
                                 placeholder="First Name"
                                 v-on:input="customer.firstname = $event.target.value" required="" autoFocus="">
                        </div>

                        <div className="form-group">
                          <input id="last_name" type="text" className="form-control" name="last_name"
                                 placeholder="Last Name"
                                 v-on:input="customer.lastname = $event.target.value" required="" autoFocus="">
                        </div>

                        <div class="form-group">
                          <input id="company_name" type="text" class="form-control" name="company_name"
                                 placeholder="Company Name" v-on:input="customer.company = $event.target.value"
                                 required="" autofocus="">

                        </div>

                        <div className="form-group">

                          <input id="email" type="email" className="form-control" name="email" placeholder="Email"
                                 v-on:input="customer.email = $event.target.value" required="required">
                        </div>

                        <div class="form-group">

                          <input id="phone" type="phone" class="form-control" name="password" placeholder="Phone"
                                 required="" v-on:input="customer.phone = $event.target.value">

                        </div>


                        <div className="form-group">
                          <div className="checkbox">
                            <label>
                              <div className="icheckbox_square-green">
                                <input type="checkbox" required="required">
                                <ins className="iCheck-helper"></ins>
                              </div>
                              <i></i> I agree to the <a href="/terms" target="_blank">terms and privacy policy</a>
                            </label>

                          </div>
                        </div>

                        <!--            <a href="https://console.skippr.io/register" class="btn btn-secondary" type="submit">Try The Beta</a>-->

                      </div>


                      <button v-on:click="send()" className="btn btn-primary block pull-right full-width m-b">Try Now <i
                        className="fa fa-arrow-circle-right"></i></button>

                    </div>
                  </div>

<!--                </div>-->

<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>

export default {
  name: 'ContactUsFrom',
  components: {},
  props: {
    msg: String,
  },
  data() {
    return {
      customer: {
        firstname: '',
        lastname: '',
        company: '',
        email: '',
        phone: '',
      }
    }
  },
  created() {
    this.$gtag.event('screen_view', {
      'screen_name': 'contact-us-form'
    });
  },
  methods: {
    clickEvent(name) {
      this.$gtag.event('click', {
        event_category: 'contact-us',
        event_label: name,
      })
    },
    async send() {

      // validate email is valid
      if (!this.customer.email.includes('@') && !this.customer.email.includes('.')) {
        alert('Please enter a valid email address')
        return
      }

      this.clickEvent('attempt-submit-contact-us-from')


      try {

        // track conversion
        this.$gtag.event('contact_us_submit', {
          event_category: 'contact-us',
          // transaction_id: license_key,
          value: 1,
          currency: 'USD',
          // callback: () => {
          //   console.log('conversion tracked, redirecting');
          // }
        });

        window.axioslicense.put('/', this.customer).then((res) => {
          let license_key = res.data.license_key

          window.location = 'https://docs.skippr.io/getting-started/docker?license_key=' + license_key

          // setTimeout(() => {
          //   window.location = 'https://docs.skippr.io/getting-started/docker?license_key=' + license_key
          // }, 10000)


        }).catch((err) => {
          console.log(err);
          // window.location = 'https://docs.skippr.io/getting-started/docker'

        });

      } catch (err) {
        console.log(err);
      }

      // }

    },
  },
  head: {

    title: {
      inner: 'Contact Us',
      separator: '-',
      complement: 'Data Integration and Preparation'
    },
    //omited
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
